import http, { host } from "./httpService";

export const getVGMData = async (date) => {
  return await http.get(host + "GetVGMData", { params: { _fromdate: date.fromdate, _todate:date.todate } });
};

export const insertVGMData = async (data) => {
  return await http.post(host + "AddVGMData", { _AdVGm: [data] });
};

export const insertAggregateVGMData = async (data) => {
  return await http.post(host + "AddVGMAggregateData", { _AdVGmAgg: [data] });
};

export const insert5MVGMData = async (data) => {
  return await http.post(host + "AddVGM5MData", { _AdVGm5m: [data] });
};

export const updateVGMData = async (data) => {
  return await http.put(host + "UpdateSingleRowforVGMData", data);
};

export const updateAggregateVGMData = async (data) => {
  return await http.put(host + "UpdateSingleRowforVGMAggData", data);
};

export const updateFiveMVGMData = async (data) => {
  return await http.put(host + "UpdateSingleRowforVGM5MData", data);
};

export const uploadVGMDocTractor = async (data) => {
  return await http.put(host + `UpdateVgmDocTr`, data);
};

export const uploadVGMDocAggregate = async (data) => {
    return await http.put(host + `UpdateVgmDocAgg`, data);
};

export const uploadVGMDocFiveM = async (data) => {
    return await http.put(host + `UpdateVgmDoc5M`, data);
};

export const deleteVGMDataTractor = async (data, action) => {
  return await http.delete(host + "DeleteAryabhata_VGMData", {params:{_id:data, _isVGMData: action}})
}

export const deleteVGMDataAggregate = async (data, action) => {
  return await http.delete(host + "DeleteAryabhataAggregate_VGMData", {params:{_id:data, _isVGMData: action}})
}

export const deleteVGMDataFiveM = async (data, action) => {
  return await http.delete(host + "DeleteAryabhata5M_VGMData", {params:{_id:data, _isVGMData: action}})
}

export const getJDPersonName = async () =>{
  return await http.get(host + "GetAryabhataJDpersonNameList")
}

export const getPickupLocation = async () =>{
  return await http.get(host + "GetAryabhataPickuplocationList")
}

export const deleteAllVGMData = async (data) => {
  return await http.delete(host + "DeleteMultipVGMData", {data:{_Bulkdelete : data}}, );
};